export function Experience() {
  return (
    <div>
      <h2 className="font-extrabold">EXPERIENCE</h2>
      <ul className="mt-4 flex flex-col flex-cols-1 text-slate-400 space-y-10">
        <li>
          <p className="text-xs font-extrabold text-slate-500">
            SEP 2025 - PRESENT
          </p>
          <h3>
            <a
              href="https://lloydsbankinggroup.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg text-slate-200 hover:text-slate-300 font-semibold"
            >
              Lloyds Banking Group
            </a>
          </h3>
          <h4 className="mt-1 text-xs font-extrabold">
            TECHNOLOGY ENGINEERING GRADUATE
          </h4>
          <p className="text-sm mt-3">
            Currently working in Data, Advanced Analytics & Insights working
            with colleague data to produce internally consumed dashboards.
          </p>

          <ul className="mt-3 flex flex-row space-x-2 text-sm font-semibold cursor-default">
            <li className="bg-sky-950 rounded-3xl px-2 py-0.5 text-sky-300">
              Python
            </li>
            <li className="bg-emerald-950 rounded-3xl px-2 py-0.5 text-emerald-300">
              PostgreSQL
            </li>
            <li className="bg-yellow-950 rounded-3xl px-2 py-0.5 text-yellow-300">
              DuckDB
            </li>
            <li className="bg-pink-950 rounded-3xl px-2 py-0.5 text-pink-300">
              Pandas
            </li>
          </ul>
        </li>

        <li>
          <p className="text-xs font-extrabold text-slate-500">
            JUN 2024 - SEP 2024
          </p>
          <h3>
            <a
              href="https://business.bt.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg text-slate-200 hover:text-slate-300 font-semibold"
            >
              BT Business
            </a>
          </h3>
          <h4 className="mt-1 text-xs font-extrabold">
            TECHNICAL DESIGNER (INTERNSHIP)
          </h4>
          <p className="text-sm mt-3">
            Summer internship on SDN and SD-WAN within the business,
            accumulating in presenting an end-to-end design for multi-national
            business connectivity including Internet, MPLS, and Call Centre
            offerings.
          </p>

          <ul className="mt-3 flex flex-row space-x-2 text-sm font-semibold cursor-default">
            <li className="bg-violet-950 rounded-3xl px-2 py-0.5 text-violet-300">
              SDN
            </li>
            <li className="bg-teal-950 rounded-3xl px-2 py-0.5 text-teal-300">
              SD-WAN
            </li>
          </ul>
        </li>

        <li>
          <p className="text-xs font-extrabold text-slate-500">
            JUL 2022 - SEP 2023
          </p>
          <h3>
            <a
              href="https://virginmediao2.co.uk"
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg text-slate-200 hover:text-slate-300 font-semibold"
            >
              Virgin Media O2
            </a>
          </h3>
          <h4 className="mt-1 text-xs font-extrabold">
            CORE TRANSMISSION DESIGNER (PLACEMENT)
          </h4>
          <p className="text-sm mt-3">
            Placement designing connectivity solutions over a core network.
            Became a Subject Matter expert on new design topologies and
            facilitated automation and process improvement across the team.
          </p>

          <ul className="mt-3 flex flex-row space-x-2 text-sm font-semibold cursor-default">
            <li className="bg-fuchsia-950 rounded-3xl px-2 py-0.5 text-fuchsia-300">
              DWDM
            </li>
            <li className="bg-lime-950 rounded-3xl px-2 py-0.5 text-lime-300">
              VBA
            </li>
            <li className="bg-blue-950 rounded-3xl px-2 py-0.5 text-blue-300">
              Visio
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
}
